<template>
	<div class="page-commerce-home" v-scroll="onScroll">
		<home-banner
			:banners="banners"
			:categories="categories"
			:commerce="commerce"
			:scroll-active="scrollActive"
			:show-all="showAll"
			:translate-value="translateValue"
			@change-banner="changeBanner"
		></home-banner>
		<section-offers-and-best-sellers
			:filters="filters"
			:products-by-filters="productsByFilters"
		></section-offers-and-best-sellers>
		<app-footer
			:services="services"
			:sections="sections"
		></app-footer>
	</div>
</template>

<script>
	import appFooter from '@/components/market-place/app-footer';
	import sectionOffersAndBestSellers from '@/components/market-place/section-offers-and-best-sellers';
	import homeBanner from '@/components/market-place/home-store/home-banner';

	function created() {
		this.token = localStorage.getItem('casamarket::commerce-token');
		this.loadFilters();
		this.categories = this.categories.map((c, index) => {
			const newCategory = { ...c };
			newCategory.background = index === 4 || index === 5 ?
				`/static/images-new/sections/background-categories-${index + 2}.jpg`
				: `/static/images-new/sections/background-categories-${index + 2}.jpeg`;
			newCategory.icon = `/static/images-new/icons/icon-categories-${index + 1}.svg`;
			newCategory.selected = false;
			return newCategory;
		});
	}

	function changeBanner(index) {
		this.banners = this.banners.map((b, bIndex) => {
			const newBanner = { ...b };
			newBanner.active = bIndex === index;
			return newBanner;
		});
		const tag = document.getElementById('banner-size');
		const tagSize = tag.offsetWidth;
		this.translateValue = -(index * tagSize);
	}

	async function loadFilters() {
		const headers = {
			Authorization: `Bearer ${this.token}`,
		};
		({ data: this.filters } = await this.$httpProducts.get('filters-public', { headers }));
		this.loadProductsByFilters();
	}

	async function loadProductsByFilters() {
		const headers = {
			Authorization: `Bearer ${this.token}`,
		};
		const params = {
			filters: this.filters.reduce((a, f) => {
				const newA = [];
				newA.push(f.id);
				const newString = !a ? a.concat(newA) : a.concat(`,${newA}`);
				return newString;
			}, ''),
		};
		({ data: this.productsByFilters } = await this.$httpProducts.get('products-public',
			{ headers, params }));
		this.productsByFilters = this.productsByFilters.map((pf) => {
			const newProduct = { ...pf };
			newProduct.quantity = pf.quantity || 1;
			return newProduct;
		});
	}

	function onScroll({ path }) {
		const { scrollY } = path[1];
		this.scrollActive = scrollY > 700;
	}

	function selectedAll() {
		this.categories = this.categories.map((c) => {
			const newCategory = { ...c };
			newCategory.selected = false;
			return newCategory;
		});
		this.showAll = true;
	}

	function selectedCategory({ id }) {
		this.showAll = false;
		this.categories = this.categories.map((c) => {
			const newCategory = { ...c };
			newCategory.selected = c.id === id;
			return newCategory;
		});
		this.categorySelected = this.categories.find(c => c.selected);
	}

	function data() {
		return {
			banners: [
				{
					id: 1,
					active: true,
					btn: 'COMPRAR AHORA',
					link: '#',
					urlImage: '/static/images-new/banners/banner-1.jpeg',
				},
				{
					id: 2,
					active: false,
					btn: 'COMPRAR AHORA',
					link: '#',
					urlImage: '/static/images-new/banners/banner-2.jpeg',
				},
				{
					id: 3,
					active: false,
					btn: 'COMPRAR AHORA',
					link: '#',
					urlImage: '/static/images-new/banners/banner-3.jpg',
				},
			],
			categories: [
				{
					id: 7,
					name: 'Carnicería',
					totalCommerce: 0,
				},
				{
					id: 8,
					name: 'Bodega Minimarket',
					totalCommerce: 0,
				},
				{
					id: 41,
					name: 'Frutería',
					totalCommerce: 0,
				},
				{
					id: 42,
					name: 'Abarrotes',
					totalCommerce: 0,
				},
				{
					id: 43,
					name: 'Verduras',
					totalCommerce: 0,
				},
				{
					id: 44,
					name: 'Dulcerías',
					totalCommerce: 0,
				},
			],
			commerce: {
				id: 1,
				distance: '3km',
				logo: '/static/images-new/logos/logo-store-default.png',
				name: 'Nombre de tienda',
				social: [
					{
						id: 1,
						background: '#3b5998',
						height: 19,
						link: '#',
						logo: '/static/images-new/logos/logo-social-facebook.svg',
						name: 'facebook',
					},
					{
						id: 2,
						background: '#fc6a6a',
						height: 12,
						link: '#',
						logo: '/static/images-new/logos/logo-social-google-plus.svg',
						name: 'google plus',
					},
					{
						id: 3,
						background: '#ff369c',
						height: 17,
						link: '#',
						logo: '/static/images-new/logos/logo-social-instagram.svg',
						name: 'instagram',
					},
				],
			},
			filters: [],
			productsByFilters: [],
			sections: [
				{
					id: 1,
					name: 'NOSOTROS',
					links: [
						{
							id: 1,
							name: '¿Quiénes somos?',
							href: '#',
						},
						{
							id: 2,
							name: 'Trabaja con nosotros',
							href: '#',
						},
					],
				},
				{
					id: 2,
					name: 'TIENDA ONLINE',
					links: [
						{
							id: 1,
							name: 'Beneficios',
							href: '#',
						},
						{
							id: 2,
							name: 'Legales',
							href: '#',
						},
						{
							id: 3,
							name: 'Preguntas legales',
							href: '#',
						},
						{
							id: 4,
							name: 'Terminos y condiciones',
							href: '#',
						},
						{
							id: 5,
							name: 'Políticas de privacidad y seguridad',
							href: '#',
						},
					],
				},
				{
					id: 3,
					name: 'CONTÁCTANOS',
					links: [
						{
							id: 1,
							name: 'Tiendas',
							href: '#',
						},
						{
							id: 2,
							name: 'Consultas y sugerencias',
							href: '#',
						},
						{
							id: 3,
							name: 'Código de ética',
							href: '#',
						},
					],
				},
			],
			services: [
				{
					id: 1,
					icon: 'help_outline',
					link: '#',
					message: 'Si tienes alguna duda ingresa aquí',
					title: 'Cómo Comprar',
				},
				{
					id: 2,
					link: '#',
					message: 'Conoce tu tienda más cercana',
					title: 'Tiendas',
					urlImage: '/static/images-new/icons/icon-store.svg',
				},
				{
					id: 3,
					icon: 'local_shipping',
					link: '#',
					message: 'Conoce nuestros métodos de envío',
					title: 'Servicios de entrega',
				},
				{
					id: 4,
					icon: 'credit_card',
					link: '#',
					message: 'Conoce nuestros medios de pago',
					title: 'Medios de pago',
				},
			],
			showAll: true,
			scrollActive: false,
			token: '',
			translateValue: 0,
		};
	}

	export default {
		name: 'page-commerce-home',
		components: {
			appFooter,
			homeBanner,
			sectionOffersAndBestSellers,
		},
		created,
		data,
		methods: {
			changeBanner,
			loadFilters,
			loadProductsByFilters,
			onScroll,
			selectedAll,
			selectedCategory,
		},
	};
</script>

<style lang="scss" scoped>
	.page-commerce-home {
		padding-top: 61px;

		@media (min-width: 936px) {
			padding-top: 82px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/market-place/page-commerce-home.vue